import React,{Component} from "react";
import { Field, reduxForm, change } from "redux-form";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, UncontrolledTooltip, CardFooter } from "reactstrap";
import { renderPass, renderField, renderCheckbox, renderTextArea, required, number, positive_float, empty_or_number } from "../../../utils/formValidations.js";
import { connect } from "react-redux";
import { getServers} from "../../../actions/actionServer";
import { getServerPools} from "../../../actions/actionServerPool";
import { getZones } from "../../../actions/actionZones";
import { getImages, getServerCustomNetworkNames, updateImages } from "../../../actions/actionImage";
import { NotificationManager } from "react-notifications";
import { withRouter } from "react-router-dom";
import Proptypes from "prop-types";
import SelectInput from "../../../components/SelectInput";
import {getUrlFilterPolicies} from "../../../actions/actionFilters"

const renderOption = (option) => {
    return (
        <div>  {option.hostname} : {option.label} </div>
    );
};

const renderValue = (option) => {    
    return ( 
        <div> {option.hostname} : {option.label} </div>
    );
};

class ImageFormTemplate extends Component  {
    constructor(props){
        super(props);
        this.state  = {
            currentImage: null,
            currentNetwork: null,
            currentServers: null,
            currentZones: null,
        };
        this.submitImage= this.submitImage.bind(this);
        this.cancelButton = this.cancelButton.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
        this.handleCreateSuccess = this.handleCreateSuccess.bind(this);
        this.getServerClickFunc = this.getServerClickFunc.bind(this);
        this.getServerIdFunc = this.getServerIdFunc.bind(this);
        this.getZoneIdFunc = this.getZoneIdFunc.bind(this);
    }

    handleUpdateSuccess(){
        const {updateErrorImagesMessage} = this.props;

        //Changes memory back to MB display on form error
        this.props.dispatch(change('imageForm', 'memory', this.props.imageFormValues.memory/1000000 ));

        if(updateErrorImagesMessage){
            NotificationManager.error(updateErrorImagesMessage,"Update Workspace", 3000);
        }
        else {
            NotificationManager.success("Image Update", "Successfully Updated Image");
            this.props.history.push("/workspaces");
        }
    }

    handleUpdateError(){
        const {updateImagesError} = this.props;

        //Changes memory back to MB display on form error
        this.props.dispatch(change('imageForm', 'memory', this.props.imageFormValues.memory/1000000 ));

        if(updateImagesError){
            NotificationManager.error(updateImagesError,"Update Workspace", 3000);
        }
    }

    handleCreateSuccess(){
        const {errorCreateImageMessage} = this.props;

        //Changes memory back to MB display on form error
        this.props.dispatch(change('imageForm', 'memory', this.props.imageFormValues.memory/1000000 ));

        if(errorCreateImageMessage){
            NotificationManager.error(errorCreateImageMessage,"Create Workspace", 3000);
        }
        else{
            NotificationManager.success("Image Created", "Successfully Created Image");
            this.props.history.push("/workspaces");
        }
    }

    handleCreateError(){
        const {createImagesError} = this.props;

        //Changes memory back to MB display on form error
        this.props.dispatch(change('imageForm', 'memory', this.props.imageFormValues.memory/1000000 ));

        if(createImagesError){
            NotificationManager.warning(createImagesError,"Update Workspace", 3000);
        }
    }

    submitImage(userData){
        if (!userData.enabled)
            userData.enabled = false;
        if (this.props.fromUpdate){
            if (userData.memory < 256 || userData.memory > 256000) {
                NotificationManager.error("Memory must be between 256 and 256000","Invalid Memory Selection", 3000);
                return
            }
            userData.gpu_count = userData.gpu_count === "" ? null : userData.gpu_count ;
            userData.memory = userData.memory * 1000000;
            userData.restrict_network_names = userData.restrict_to_network == true ? userData.restrict_network_names : [];
            userData.server_id = userData.restrict_to_server == true ? userData.server_id : "";
            userData.zone_id = userData.restrict_to_zone == true ? userData.zone_id : "";

            if (this.props.fromClone) {
                this.props.createImage(userData).then(() => this.handleCreateSuccess()).catch(() => this.handleCreateError());

            }
            else {
                userData.image_id = this.state.currentImage.image_id;
                this.props.updateImages(userData).then(() => this.handleUpdateSuccess()).catch(() => this.handleUpdateError());
            }
        }
        else {
            userData.gpu_count = userData.gpu_count === "" ? null : userData.gpu_count ;
            userData.memory = userData.memory * 1000000;
            this.props.createImage(userData).
                then(() => this.handleCreateSuccess()).
                catch(() => this.handleCreateError());
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.images.length > 0 && this.props.images !== nextProps.images && this.props.getImagesLoading && this.props.fromUpdate){
            let currentImage = nextProps.images.find(images => images.image_id === this.props.imageId);
            let currentNetworks = nextProps.network_names.find(network_names => network_names === currentImage.network_name);
            //let currentServers =  nextProps.servers.find(servers => servers.server_id === currentImage.server_id);
            this.setState({currentImage: currentImage});
            this.props.initialize({
                name: currentImage.name,
                description: currentImage.description, 
                memory: currentImage.memory/1000000,
                friendly_name: currentImage.friendly_name,
                image_src: currentImage.image_src,
                cores: currentImage.cores,
                require_gpu: currentImage.require_gpu,
                gpu_count: currentImage.gpu_count,
                enabled: currentImage.enabled,
                docker_registry: currentImage.docker_registry,
                docker_token: currentImage.docker_token,
                docker_user: currentImage.docker_user,
                hash: currentImage.hash,
                persistent_profile_path: currentImage.persistent_profile_path,
                volume_mappings: JSON.stringify(currentImage.volume_mappings, null, 2),
                run_config: JSON.stringify(currentImage.run_config, null, 2),
                exec_config: JSON.stringify(currentImage.exec_config, null, 2),
                categories: currentImage.categories ? currentImage.categories.join('\n') : '',
                restrict_to_network: currentImage.restrict_to_network,
                restrict_network_names: currentImage.restrict_network_names,
                allow_network_selection: currentImage.allow_network_selection,
                restrict_to_server: currentImage.restrict_to_server,
                server_id: currentImage.server_id,
                server_pool_id: currentImage.server_pool_id,
                restrict_to_zone: currentImage.restrict_to_zone,
                zone_id: currentImage.zone_id,
                filter_policy_id: currentImage.filter_policy_id,
                session_time_limit: currentImage.session_time_limit,
                hidden: currentImage.hidden,
                notes: currentImage.notes,
                image_type: currentImage.image_type,
                link_url: currentImage.link_url,
                cpu_allocation_method: currentImage.cpu_allocation_method,
            });
        }
    }

    cancelButton(){
        this.props.history.push("/workspaces");
    }

    componentDidMount(){
        this.props.getUrlFilterPolicies();
        this.props.getServers()
        this.props.getServerPools()
        if (this.props.fromUpdate){
            this.props.getImages();
            this.props.getServerCustomNetworkNames();
        }
    }

    getServerIdFunc(){
        this.props.getServers();
    }

    getZoneIdFunc(){
        this.props.getZones();
    }

    getServerClickFunc(){
        this.props.getServerCustomNetworkNames();
    }

    render(){
        const {handleSubmit, network_names, servers, zones, imageFormValues, filters, server_pools} = this.props;
        const {currentImage} =  this.state;
        const checked = currentImage && currentImage.enabled;
        const allow_network_selection = currentImage && currentImage.allow_network_selection;
        const restrict_to_network = currentImage && currentImage.restrict_to_network;
        const restrict_to_server = currentImage && currentImage.restrict_to_server;
        const restrict_to_zone = currentImage && currentImage.restrict_to_zone;
        const require_gpu = currentImage && currentImage.require_gpu;
        const hidden = currentImage && currentImage.hidden;
        const notes = currentImage && currentImage.notes;
        let options = [];
        for(let i=0 ; i < network_names.length ; i++){
            options.push({ label: network_names[i], value: network_names[i]});
        }
        options.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);

        let optionsAgent = [];
        servers.map(opt => {
            if (opt.server_type === "host") {
                optionsAgent.push({label: opt.server_id.substring(0, 6), value: opt.server_id, hostname: opt.hostname});
            }
        });
        optionsAgent.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);

        let optionServer = [];
        servers.map(opt => {
            if (opt.server_type === "Desktop" && opt.is_autoscaled === false) {
                optionServer.push({label: opt.friendly_name, value: opt.server_id, hostname: opt.hostname });
            }
        });
        optionServer.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);

        let optionServerPools = [];
        server_pools.map(opt => {
            optionServerPools.push({label: opt.server_pool_name, value: opt.server_pool_id});
        });
        optionServerPools.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);

        let optionsZones = [];
        zones.map(opt => {
            optionsZones.push({label: opt.zone_name, value: opt.zone_id, zone_name: opt.zone_name });
        });
        optionsZones.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);

        let optionsFilters = [{label: "Inherit", value: "inherit"}, {label: "Force Disabled", value: "force_disabled"}];
        filters.map(opt => {
            optionsFilters.push({label: opt.filter_policy_name, value: opt.filter_policy_id});
        });
        optionsFilters.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);

        let filter_policy_id_value = "inherit";
        if (currentImage && currentImage.filter_policy_force_disabled) {
            filter_policy_id_value = "force_disabled";
        }
        if (imageFormValues && imageFormValues.filter_policy_id) {
            filter_policy_id_value = imageFormValues.filter_policy_id;
        }

        let optionsImageType = [{label: "Container", value: "Container"},   {label: "Link", value: "Link"}, {label: "Server", value: "Server"}, {label: "Pool", value: "Server Pool"},];
        let optionsConnectionType = [{label: "KasmVNC", value: "KasmVNC"}, {label: "RDP", value: "RDP"}];

        let optionsCpuAllocationMethods = [{label: "Inherit", value: "Inherit"},   {label: "Quotas", value: "Quotas"}, {label: "Shares", value: "Shares"}];



        return (
            <Form onSubmit={handleSubmit(this.submitImage)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="name" className="requiredasterisk">Workspace Type</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field name="image_type"
                                       selectedValue={imageFormValues && imageFormValues.image_type ? imageFormValues.image_type: ""}
                                       options={optionsImageType}
                                       validate={required}
                                       isUpdateForm={this.props.fromUpdate}
                                       component={SelectInput}
                                       disabled={this.state.currentImage && this.state.currentImage.image_id ? true : false}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="friendly_name" className="requiredasterisk">Friendly Name</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="friendly_name"
                                    name="friendly_name"
                                    id="friendly_name"
                                    component={renderField}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="description" className="requiredasterisk">Description</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field
                                    type="description"
                                    name="description"
                                    id="description"
                                    component={renderField}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="image_src">Thumbnail URL</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="image_src"
                                    name="image_src"
                                    id="image_src"
                                    component={renderField}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="enabled" className="pull-left">Enabled &nbsp;</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="enabled">
                                    <Field name="enabled"
                                        id="enabled"
                                        checked = {checked}
                                        type ="checkbox"
                                        component={renderCheckbox}
                                    />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup>

                    { imageFormValues && imageFormValues.image_type === "Link" ?
                        <React.Fragment>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="link_url">URL</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="text"
                                            name="link_url"
                                            id="link_url"
                                            component={renderField}
                                            validate={required}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                        </React.Fragment>
                    : ""}

                    { imageFormValues && imageFormValues.image_type === "Server" ?
                        <React.Fragment>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="server_id">Server</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field name="server_id"
                                            selectedValue={imageFormValues.server_id}
                                            options={optionServer}
                                            renderOption={renderOption}
                                            renderValue={renderValue}
                                            isUpdateForm={this.props.fromUpdate}
                                            validate={required}
                                            component={SelectInput}  />
                                    </Col>
                                </Row>
                            </FormGroup>
                        </React.Fragment>
                    : ""}

                    { imageFormValues && imageFormValues.image_type === "Server Pool" ?
                        <React.Fragment>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="server_pool_id">Pool</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field name="server_pool_id"
                                            selectedValue={imageFormValues.server_pool_id}
                                            options={optionServerPools}
                                            isUpdateForm={this.props.fromUpdate}
                                            validate={required}
                                            component={SelectInput}  />
                                    </Col>
                                </Row>
                            </FormGroup>
                        </React.Fragment>
                    : ""}


                    { imageFormValues && imageFormValues.image_type === "Container" ?
                        <React.Fragment>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="name" className="requiredasterisk">Docker Image</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="text"
                                            name="name"
                                            id="name"
                                            component={renderField}
                                            validate={required}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="cores" className="requiredasterisk">Cores</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="number"
                                            name="cores"
                                            id="cores"
                                            component={renderField}
                                            validate={[required, positive_float]}
                                            placeholder="1"
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="memory" className="requiredasterisk">Memory (MB)</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="number"
                                            name="memory"
                                            id="memory"
                                            component={renderField}
                                            validate={[required, number]}
                                            placeholder="1768"
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>

                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="gpu_count" >GPU Count</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="number"
                                            name="gpu_count"
                                            id="gpu_count"
                                            component={renderField}
                                            validate={[number]}
                                            placeholder="0"
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="cpu_allocation_method" className="requiredasterisk">CPU Allocation Method</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field name="cpu_allocation_method"
                                               selectedValue={imageFormValues && imageFormValues.cpu_allocation_method ? imageFormValues.cpu_allocation_method: ""}
                                               options={optionsCpuAllocationMethods}
                                               validate={required}
                                               isUpdateForm={this.props.fromUpdate}
                                               component={SelectInput}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="docker_registry">Docker Registry</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="docker_registry"
                                            name="docker_registry"
                                            id="docker_registry"
                                            component={renderField}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="docker_user">Docker Registry Username</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="docker_user"
                                            name="docker_user"
                                            id="docker_user"
                                            component={renderField}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="docker_token">Docker Registry Password</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="password"
                                            name="docker_token"
                                            id="docker_token"
                                            component={renderPass}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="hash">Hash</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="hash"
                                            name="hash"
                                            id="hash"
                                            component={renderField}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="persistent_profile_path">Persistent Profile Path</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="persistent_profile"
                                            name="persistent_profile_path"
                                            id="persistent_profile_path"
                                            component={renderField}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="volume_mappings">Volume Mappings (JSON)</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="textarea"
                                            name="volume_mappings"
                                            id="volume_mappings"
                                            component={renderTextArea}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="run_config">Docker Run Config Override (JSON)</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="textarea"
                                            name="run_config"
                                            id="run_config"
                                            component={renderTextArea}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="exec_config">Docker Exec Config (JSON)</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="textarea"
                                            name="exec_config"
                                            id="exec_config"
                                            component={renderTextArea}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="filter_policy_id">Web Filter Policy</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field name="filter_policy_id"
                                            selectedValue={filter_policy_id_value}
                                            options={optionsFilters}
                                            isUpdateForm={this.props.fromUpdate}
                                            component={SelectInput}  />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <UncontrolledTooltip placement="right" target={"Tooltips"}>
                                          Allow users to select the docker network the session is provisioned on.
                                        </UncontrolledTooltip>
                                        <Label htmlFor="allow_network_selection" className="pull-left"> Allow Network Selection <span id={"Tooltips"}> </span></Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Label check htmlFor="allow_network_selection">
                                            <Field name="allow_network_selection"
                                                id="allow_network_selection"
                                                checked = {allow_network_selection}
                                                type ="checkbox"
                                                component={renderCheckbox}
                                            />
                                        </Label>
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <UncontrolledTooltip placement="right" target={"Tooltips"}>
                                          Kasm Images can be configured to be provision on custom docker networks pre-configured on Kasm Servers.
                                        </UncontrolledTooltip>
                                        <Label htmlFor="restrict_to_network" className="pull-left"> Restrict Image to Docker Network <span id={"Tooltips"}> </span></Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Label check htmlFor="restrict_to_network">
                                            <Field name="restrict_to_network"
                                                id="restrict_to_network"
                                                checked = {restrict_to_network}
                                                onChange={()=> this.getServerClickFunc()}
                                                type ="checkbox"
                                                component={renderCheckbox}
                                            />
                                        </Label>
                                    </Col>
                                </Row>
                            </FormGroup>
                            { imageFormValues && imageFormValues.restrict_to_network === true ?
                                <FormGroup>
                                    <Row>
                                        <Col>
                                            <Label htmlFor="restrict_network_names">Docker Networks</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field name="restrict_network_names"
                                                selectedValue={imageFormValues.restrict_network_names}
                                                options={options}
                                                validate={required}
                                                multi
                                                isUpdateForm={this.props.fromUpdate}
                                                component={SelectInput}  />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                : "" }
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <UncontrolledTooltip placement="right" target={"TooltipComponent"}>
                                         Kasm Images can be configured to be provisioned only on certain Kasm Servers.
                                        </UncontrolledTooltip>
                                        <Label htmlFor="restrict_to_server" className="pull-left">Restrict Image to Kasm Agent<span id={"TooltipComponent"}> </span></Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Label check htmlFor="restrict_to_server">
                                            <Field name="restrict_to_server"
                                                id="restrict_to_server"
                                                onChange={()=> this.getServerIdFunc()}
                                                checked = {restrict_to_server}
                                                type ="checkbox"
                                                component={renderCheckbox}
                                            />
                                        </Label>
                                    </Col>
                                </Row>
                            </FormGroup>
                            { imageFormValues && imageFormValues.restrict_to_server === true ?
                                <FormGroup>
                                    <Row>
                                        <Col>
                                            <Label htmlFor="server_id">Kasm Server</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field name="server_id"
                                                selectedValue={imageFormValues.server_id}
                                                options={optionsAgent}
                                                renderOption={renderOption}
                                                renderValue={renderValue}
                                                isUpdateForm={this.props.fromUpdate}
                                                validate={required}
                                                component={SelectInput}  />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                : ""}
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <UncontrolledTooltip placement="right" target={"TooltipComponent"}>
                                         Kasm Images can be configured to be provisioned only on Kasm Servers in the particular Zone.
                                        </UncontrolledTooltip>
                                        <Label htmlFor="restrict_to_zone" className="pull-left">Restrict Image to a Deployment Zone<span id={"TooltipComponent"}> </span></Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Label check htmlFor="restrict_to_zone">
                                            <Field name="restrict_to_zone"
                                                id="restrict_to_zone"
                                                onChange={()=> this.getZoneIdFunc()}
                                                checked = {restrict_to_zone}
                                                type ="checkbox"
                                                component={renderCheckbox}
                                            />
                                        </Label>
                                    </Col>
                                </Row>
                            </FormGroup>
                            { imageFormValues && imageFormValues.restrict_to_zone === true ?
                                <FormGroup>
                                    <Row>
                                        <Col>
                                            <Label htmlFor="server_id">Deployment Zone</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field name="zone_id"
                                                selectedValue={imageFormValues.zone_id}
                                                options={optionsZones}
                                                isUpdateForm={this.props.fromUpdate}
                                                validate={required}
                                                component={SelectInput}  />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                : ""}
                        </React.Fragment>
                    : ""}
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="categories">Categories (One Per Line)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="textarea"
                                    name="categories"
                                    id="categories"
                                    component={renderTextArea}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    { imageFormValues && imageFormValues.image_type != "Link" ?
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="session_time_limit">Session Time Limit (Seconds) </Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="number"
                                        name="session_time_limit"
                                        id="session_time_limit"
                                        component={renderField}
                                        validate={empty_or_number}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                    : "" }
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="hidden" className="pull-left">Hide Image on Dashboard &nbsp;</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="hidden">
                                    <Field name="hidden"
                                        id="hidden"
                                        checked = {hidden}
                                        type ="checkbox"
                                        component={renderCheckbox}
                                    />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="notes">Notes</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="textarea"
                                    name="notes"
                                    id="notes"
                                    component={renderTextArea}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="cancel" size="sm"
                        className="cancel-button"
                        color="basic" onClick={() => this.cancelButton()}> Cancel</Button>
                        <Button type="submit" size="sm" 
                        className="submit-button"
                        color="primary">Submit</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}

ImageFormTemplate.propTypes = {
    updateImages: Proptypes.func.isRequired,
    getImages: Proptypes.func.isRequired,
    getServerCustomNetworkNames: Proptypes.func.isRequired,
    updatErrorWarning: Proptypes.func,
    history: Proptypes.object.isRequired,
    updateImagesError: Proptypes.func,
    updateErrorImagesMessage: Proptypes.string,
    createImagesError: Proptypes.func,
    fromUpdate: Proptypes.bool,
    fromClone: Proptypes.bool,
    errorCreateImageMessage: Proptypes.string,
    error_message: Proptypes.string,
    createImage: Proptypes.func,
    images: Proptypes.array,
    getImagesLoading: Proptypes.bool,
    initialize: Proptypes.func,
    imageFormValues: Proptypes.object,
    network_names: Proptypes.array,
    getServers: Proptypes.func,
    getServerPools: Proptypes.func,
    getZones: Proptypes.func,
    handleSubmit: Proptypes.func,
    imageId: Proptypes.string,
    servers: Proptypes.array,
    server_pools: Proptypes.array,
    zones: Proptypes.array,
    filters: Proptypes.array,
};

let ImageFormWithRouter = withRouter(ImageFormTemplate);


let ImageForm =  connect(state =>
    ({

        images: state.images.images || [],
        network_names: state.images.network_names || [],
        servers: state.servers.servers || [],
        server_pools: state.server_pools.server_pools || [],
        zones: state.zones.zones || [],
        filters: state.filter.filters || [],
        imageFormValues: state.form && state.form.imageForm && state.form.imageForm.values ? state.form.imageForm.values : null,
        errorCreateImageMessage: state.images.errorCreateImageMessage || null,
        updateErrorImagesMessage: state.images.updateErrorImagesMessage || null,
        error_message: state.images.error_message || null,
        updateImagesError: state.images.updateImagesError || null,
        getImagesLoading: state.images.getImagesLoading || false,
        createImagesError: state.images.createImagesError || null
    }),
dispatch =>
    ({
        updateImages: (data) => dispatch(updateImages(data)),
        getServerCustomNetworkNames: () => dispatch(getServerCustomNetworkNames()),
        getServers: () => dispatch(getServers()),
        getServerPools: () => dispatch(getServerPools()),
        getZones: () => dispatch(getZones()),
        getImages: () => dispatch(getImages()),
        getUrlFilterPolicies: () => dispatch(getUrlFilterPolicies()),

    }))(ImageFormWithRouter);

export default reduxForm({
    form: "imageForm",
})(ImageForm);
